import React from 'react';
import AddressShowBox from "./AddressShowBox";
import CartManager from "../../../managers/cartManager/cartManager";

function ShowBillingAddress({onSubmit}) {
    const handleSubmit = () => {
        const address = Object.assign({}, CartManager.getInvoiceData().userInfo);
        delete address.email;
        CartManager.changeAddress(address);
        onSubmit();
    }

    return (
        <AddressShowBox address={CartManager.getInvoiceData().userInfo} withButton onClick={handleSubmit} selected={CartManager.getShipping().addressType === 'billing'}/>
    );
}

export default ShowBillingAddress;
